import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf'; 
import { Payment } from '../payment';
import { PaymentService } from '../payment.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import html2canvas from 'html2canvas';

declare var jsPDF: any;

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.css']
})
export class PaymentDetailsComponent implements OnInit {

  payment = new Payment();

  constructor(
    private paymentService: PaymentService,
		private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.GetPaymentDetails();
  }

  GetPaymentDetails() {
    const paymentid = +this.route.snapshot.paramMap.get('paymentid');
    this.paymentService.GetPaymentDetails(paymentid)
      .subscribe(payment =>
       { 
         this.payment = payment
       });
  }

 goBack(): void {
   this.location.back();
 }

}
